import _ from 'lodash';
import {services} from '../../../../application/service/services';
import {ResolvedParams} from '../../../model/params/resolve/ResolvedParams';
import {registerVizType} from '../../../model/viz/visualizationTypes';
import {DistributionEditor} from './DistributionEditor';
import {DistributionViz} from './DistributionViz';
import {getTitle} from "../common";
import {AbstractTableVizComponent, TableData} from "../table/AbstractTableViz";

const defaultParams = {
    size: 5
};

const defaultUiParams = {
    showPercent: true,
    showVolume: false,
    showTrend: false
};

registerVizType(
    {
        name: 'DISTRIBUTION',
        title: getTitle,
        component: DistributionViz,
        defaultParams: (vizDef) => defaultParams,
        defaultUiParams: (vizDef) => defaultUiParams,
        editor: {
            component: DistributionEditor,
            title: getTitle,
            init(vizInstance) {
                return {
                    uiParams: _.merge({}, defaultUiParams, vizInstance.definition.uiParams),
                    params: _.merge({}, defaultParams, vizInstance.definition.params),
                };
            },
            applyOnParams: (params, editedParams) => {
                Object.assign(params, editedParams);
            },
            applyOnUiParams: (uiParams, editedUiParams) => {
                Object.assign(uiParams, editedUiParams);
            }
        },
        noDataPolicy: {
            hasData: vizInstance => (vizInstance.data.totalCount > 0)
        },
        specResolver: (vizDefinitionSpec, resolvedParams: ResolvedParams) => {
            const params = vizDefinitionSpec.params;
            if (params.inclusions) {
                params.inclusions.forEach(inclusion => {
                    const field = services.getFieldsService().getField(inclusion.field);
                    /*check all  inclusions and exclusions values to replace first_level value with all corresponding values*/
                    params.inclusions = services.getDashboardService().resolveFirstLevelValues(field, inclusion.values);
                });
            }

            if (params.exclusions) {
                params.exclusions.forEach(exclusion => {
                    const field = services.getFieldsService().getField(exclusion.field);
                    /*check all  inclusions and exclusions values to replace first_level value with all corresponding values*/
                    params.exclusions = services.getDashboardService().resolveFirstLevelValues(field, params.exclusions);

                });
            }
            return vizDefinitionSpec;
        },
        prepareViz: (vizDefinitionSpec, data: TableData) => {
            /*for each item in date, we register the value in color service to assign it a color*/
            AbstractTableVizComponent.declareColor(data);
        },
        prepareData: (data) => {
            return {
                items: AbstractTableVizComponent.enrichItems(data.items, null),
                totalCount: data.totalCount,
                childrenCount: data.childrenCount
            };
        }
    }
);